export default __webpack_public_path__ + "static/media/zrak-velikost.663a821a.svg";